import * as React from 'react'

interface Props {
  children: React.ReactNode
}

export default (({ children }): React.ReactElement => {
  return (
    <div className="bg-light mb-10 px-4 py-8 xl:px-0">
      <h1 className="text-center text-2xl font-bold sm:text-2xl md:text-2xl lg:text-3xl">{children}</h1>
    </div>
  )
}) satisfies React.FC<Props>
